import React from 'react';
import './styles.css';
import '../pages/BeritaPage.css'; // Menggunakan style dari BeritaPage.css

const PrestasiSkeletonCard = ({ height }) => {
  return (
    // Menggunakan kelas untuk masonry item agar layoutnya benar saat loading
    <div className="prestasi-masonry-item skeleton-card">
      <div className="berita-card-image skeleton" style={{ height: height || '250px' }} />
      <div className="berita-card-content">
        <div className="skeleton skeleton-text" style={{ width: '40%', height: '14px' }} />
        <div className="skeleton skeleton-text" style={{ width: '80%', height: '24px' }} />
        <div className="skeleton skeleton-text" />
        <div className="skeleton skeleton-text" style={{ width: '70%' }} />
      </div>
    </div>
  );
};

export default PrestasiSkeletonCard;